import { useSyncExternalStore } from 'react';

/** App-wide toasts, shown bottom right by LiveEventsToast (e.g. "Klonen fertig ✓"). */
export interface Toast {
  id: number;
  title: string;
  body?: string;
  tone?: 'info' | 'success' | 'error';
  /** In-app path opened by clicking the toast. */
  to?: string;
}

let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((listener) => listener());

export function pushToast(toast: Omit<Toast, 'id'>, ms = 12_000) {
  const entry = { ...toast, id: nextId++ };
  toasts = [...toasts.slice(-4), entry];
  emit();
  window.setTimeout(() => dismissToast(entry.id), ms);
}

export function dismissToast(id: number) {
  if (!toasts.some((t) => t.id === id)) return;
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    () => toasts
  );
}
